/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable jsx-a11y/anchor-is-valid */
import { ErrorMessage, Field, Form, Formik } from 'formik'
import React, {useState, useRef, useMemo} from 'react'
import {Modal} from 'react-bootstrap-v5'
import { NumericFormat } from 'react-number-format'
import * as Yup from 'yup'
import { revertPriceNumner } from '../../../selectors'
import { updateOpeningConfig } from '../../store/StoreCRUD'
import { Toast } from '../../../modules/common/helper'
import { useDispatch } from 'react-redux'
import * as auth from '../../../modules/auth/redux/AuthRedux'
import { UserLoggedIn } from '../../../hooks/PermissionChecker'
import { Address, IStoreModel } from '../../../models/StoreModel'
import { AsyncSelect2 } from '../../../../_metronic/partials/select/AsyncSelect2'
import { GET_TAXGROUP_OPTIONS } from '../../../constants/endpoints'

type Props = {
  show: boolean
  mode: string,
  data?: Address,
  handleClose: () => void
  handleSave: (values: any) => void
  storeInfo?: IStoreModel
}

const schema = Yup.object().shape({
    address: Yup.string()
        .required('Trường này là bắt buộc'),
    business_address_name: Yup.string()
        .when('is_head_office', {
            is: 0,
            then: (schema) => schema.required('Trường này là bắt buộc')
        }),
    business_address_code: Yup.string()
        .when('is_head_office', {
            is: 0,
            then: (schema) => schema.required('Trường này là bắt buộc')
        }),
    // template_code: Yup.string()
    //     .when('is_head_office', {
    //         is: 0,
    //         then: (schema) => schema.required('Trường này là bắt buộc')
    //     }),
    // invoice_series: Yup.string()
    //     .when('is_head_office', {
    //         is: 0,
    //         then: (schema) => schema.required('Trường này là bắt buộc')
    //     })
})

const AddressModal: React.FC<Props> = ({ show, data, handleClose, handleSave, storeInfo }) => {
    const initValues = {
        id: data?.id ?? undefined,
        address: data?.address ?? '',
        is_default: data?.is_default ?? 1,
        is_head_office: data?.is_head_office ?? 0,
        business_address_name: data?.business_address_name ?? '',
        business_address_code: data?.business_address_code ?? '',
        invoice_type: data?.invoice_type ?? (storeInfo?.invoice_type ?? 1),
        template_code: data?.template_code ?? '',
        invoice_series: data?.invoice_series ?? ''
    }
    const onSubmit = async (values: any) => {
        handleSave(values)
    };
    return (
        <Modal
            show={show}
            onHide={handleClose}
            aria-labelledby='contained-modal-title-vcenter'
            centered
        >
            <Modal.Header className='d-flex'>
                <Modal.Title>{data?.id ? 'Địa chỉ' : 'Thêm địa chỉ'}</Modal.Title>
            </Modal.Header>
            <Modal.Body className="px-10">
                <Formik enableReinitialize validationSchema={schema} initialValues={initValues} onSubmit={onSubmit}>
                    {({ values, handleChange, setValues }) => (
                        <Form>
                            <div className="d-flex flex-column  gap-5 pt-3">
                                {values?.is_head_office != 1 && (
                                    <>
                                        <div className="fv-row flex-row-fluid fv-plugins-icon-container">
                                            <label className='form-label required' htmlFor={'tax_group_id'}>
                                                Tên địa điểm kinh doanh
                                            </label>
                                            <div className="col-12">
                                                <input 
                                                    className='form-control'
                                                    value={values?.business_address_name ?? ''}
                                                    onChange={(e) => {
                                                        handleChange({target: {name: 'business_address_name', value: e.target.value }});
                                                    }}
                                                >
                                                </input>
                                                <ErrorMessage name={'business_address_name'} className='text-danger' component='span' />
                                            </div>
                                        </div>
                                        <div className="fv-row flex-row-fluid fv-plugins-icon-container">
                                            <label className='form-label required' htmlFor={'tax_group_id'}>
                                                Mã địa điểm kinh doanh
                                            </label>
                                            <div className="col-12">
                                                <input 
                                                    className='form-control'
                                                    value={values?.business_address_code ?? ''}
                                                    onChange={(e) => {
                                                        handleChange({target: {name: 'business_address_code', value: e.target.value }});
                                                    }}
                                                >
                                                </input>
                                                <ErrorMessage name={'business_address_code'} className='text-danger' component='span' />
                                            </div>
                                        </div>
                                    </>
                                )}
                                
                                <div className="fv-row flex-row-fluid fv-plugins-icon-container">
                                    <label className='form-label required' htmlFor={'tax_group_id'}>
                                        {values?.is_head_office == 1 ? 'Địa chỉ trụ sở chính' : 'Địa chỉ địa điểm kinh doanh'}
                                    </label>
                                    <div className="col-12">
                                        <input 
                                            className='form-control'
                                            value={values?.address ?? ''}
                                            onChange={(e) => {
                                                handleChange({target: {name: 'address', value: e.target.value }});
                                            }}
                                        >
                                        </input>
                                        <ErrorMessage name={'address'} className='text-danger' component='span' />
                                    </div>
                                </div>
                                {values?.is_head_office != 1 && (
                                    <>
                                        <div className="fv-row flex-row-fluid fv-plugins-icon-container">
                                            <label className='form-label' htmlFor={'invoice_type'}>
                                                Loại hóa đơn
                                            </label>
                                            <div className="col-12">
                                                <select 
                                                    name="invoice_type"
                                                    className='form-select'
                                                    value={values?.invoice_type}
                                                    onChange={(e) => {
                                                        handleChange({target: {name: 'invoice_type', value: e.target.value }});
                                                    }}
                                                >
                                                    <option value='1'>Hóa đơn giá trị gia tăng (01GTKT)</option>
                                                    <option value='2'>Hóa đơn bán hàng (02GTTT)</option>
                                                </select>
                                                <ErrorMessage name={'invoice_type'} className='text-danger' component='span' />
                                            </div>
                                        </div>
                                        <div className="fv-row flex-row-fluid fv-plugins-icon-container">
                                            <label className='form-label' htmlFor={'tax_grotemplate_codeup_id'}>
                                                Mẫu hóa đơn
                                            </label>
                                            <div className="col-12">
                                                <input 
                                                    name="template_code"
                                                    className='form-control'
                                                    value={values?.template_code ?? ''}
                                                    onChange={(e) => {
                                                        handleChange({target: {name: 'template_code', value: e.target.value }});
                                                    }}
                                                >
                                                </input>
                                                <ErrorMessage name={'template_code'} className='text-danger' component='span' />
                                            </div>
                                        </div>
                                        <div className="fv-row flex-row-fluid fv-plugins-icon-container">
                                            <label className='form-label' htmlFor={'invoice_series'}>
                                                Ký hiệu hóa đơn
                                            </label>
                                            <div className="col-12">
                                                <input
                                                    name="invoice_series"
                                                    className='form-control'
                                                    value={values?.invoice_series ?? ''}
                                                    onChange={(e) => {
                                                        handleChange({target: {name: 'invoice_series', value: e.target.value }});
                                                    }}
                                                >
                                                </input>
                                                <ErrorMessage name={'invoice_series'} className='text-danger' component='span' />
                                            </div>
                                        </div>
                                    </>
                                )}
                                
                                <div className='fv-row flex-row-fluid fv-plugins-icon-container'>
                                    <div className='form-check form-check-custom mb-3'>
                                        <input
                                            type='checkbox'
                                            className='form-check-input'
                                            defaultChecked={values.is_head_office == 1}
                                            onChange={(e) => {
                                                handleChange({target: {name: 'is_head_office', value: e.target.checked ? 1 : 0}});
                                            }}
                                        />
                                        <label className='form-check-label' htmlFor={'number-format'}>
                                            Trụ sở chính
                                        </label>
                                    </div>
                                </div>
                                <div className='fv-row flex-row-fluid fv-plugins-icon-container'>
                                    <div className='form-check form-check-custom mb-3'>
                                        <input
                                            type='checkbox'
                                            className='form-check-input'
                                            defaultChecked={values.is_default == 1}
                                            onChange={(e) => {
                                                handleChange({target: {name: 'is_default', value: e.target.checked ? 1 : 0}});
                                            }}
                                        />
                                        <label className='form-check-label' htmlFor={'number-format'}>
                                            Đặt làm mặc định
                                        </label>
                                    </div>
                                </div>
                            </div>
                            <div className='d-flex mb-4 justify-content-between pt-8'>
                                <button className="btn btn-bg-secondary" type="button" onClick={() => handleClose()}>Hủy</button>
                                <button className="btn btn-bg-success" type="submit">Lưu</button>
                            </div>
                        </Form>
                    )}
                </Formik>
            </Modal.Body>
        </Modal>
    )
}
export {AddressModal}
